export default __webpack_public_path__ + "static/media/users-gestalt.c7eb1166.svg";